import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteTurnProps extends ModalEditComponentProps { }

const ModalDeleteTurn: React.FC<ModalDeleteTurnProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/workingCalendar/workingCalendarTurn/deleteWCalTurns',
        data: {
            ...allRowData
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteSeletecTurns', '¿Seguro que quieres eliminar los turnos de las opciones seleccionadas? '),
            subtitle: t('onceDeletedTurnsNotRecover', 'Una vez eliminados no podrás recuperarlos')
        }} />
    )
}

export default ModalDeleteTurn